module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1006-6d7248be37ea73f4b19aa4a0a396f93e.png";